import React, { createContext, useContext, useState } from 'react';
import { PostProps } from '../types/postType';

interface PlaygroundContextType {
  cachedPosts: PostProps[];
  setCachedPosts: (posts: PostProps[]) => void;
  page: number;
  setPage: (page: number) => void;
  scrollPosition: number;
  setScrollPosition: (position: number) => void;
}

const PlaygroundContext = createContext<PlaygroundContextType | undefined>(undefined);

export const PlaygroundProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cachedPosts, setCachedPosts] = useState<PostProps[]>([]);
  const [page, setPage] = useState(1);
  const [scrollPosition, setScrollPosition] = useState(0);

  return (
    <PlaygroundContext.Provider 
      value={{ 
        cachedPosts, 
        setCachedPosts, 
        page, 
        setPage,
        scrollPosition,
        setScrollPosition
      }}
    >
      {children}
    </PlaygroundContext.Provider>
  );
};

export const usePlayground = () => {
  const context = useContext(PlaygroundContext);
  if (context === undefined) {
    throw new Error('usePlayground must be used within a PlaygroundProvider');
  }
  return context;
}; 